/** Standard delay before grid search/filter changes trigger API calls. */
export const GRID_SEARCH_DEBOUNCE_MS = 1000;
